import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

import type { AnimationItem, default as Lottie } from 'lottie-web';

declare global {
	interface Window {
		lottie? : typeof Lottie;
	}
}

const LOTTIE_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.6.3/lottie_svg.min.js';
const LOTTIE_SCI = 'sha256-1LmUDzx23/AXL920x0iaqcWeIzBTGnoJ7XfihOpYd+o=';

async function getLottieScript() {
	return new Promise(resolve => {
		const el = document.createElement('script');
		el.onload = resolve;
		el.src = LOTTIE_CDN;
		el.crossOrigin = 'anonymous';
		el.integrity = LOTTIE_SCI;

		document.head.appendChild(el);
	});
}

let scriptLoader : Promise<unknown> | null = null;

export default class LottieAnimatedSVG extends Module {
		private animation! : AnimationItem;

		public on(callback : Hook) {
			if(scriptLoader === null) {
				scriptLoader = getLottieScript();
			}
			// tslint:disable-next-line:no-floating-promises
			scriptLoader
				.then(this.startLottieAnimation.bind(this))
				.catch(err => this.log(err));

			callback();
		}

		public onActiveDisplay($container : JQuery) {
			if ($container.find(this.$ctx).length) {
				this.animation.play();
			} else {
				this.animation.stop();
			}
		}

		private startLottieAnimation() {
			if(!window.lottie) {
				return;
			}
			this.animation = window.lottie.loadAnimation({
				autoplay: false,
				container: this.$ctx.find('.animation-holder').get(0),
				loop: false,
				path: this.$ctx.data('json-path'),
				renderer: 'svg',
			});
			const $hoverContainer = this.$ctx.closest('.mod.modHoverContainer');
			if($hoverContainer.length) {
				$hoverContainer.on('scs-active', (_, $container) => {
					if ($container.find(this.$ctx).length) {
						this.animation.play();
					} else {
						this.animation.stop();
					}
				});
			} else {
				this.$ctx.find('.animation-holder')
					.hover(_ => this.animation.play(), _ => this.animation.stop());
			}
		}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/lottie/Tc.Module.LottieAnimatedSVG.ts